import type { TranslationMessages } from '../types';

export const dashboard: TranslationMessages = {
    name: 'Dashboard',
    more: 'More',
    more_menu: 'More Menu',
    welcome: {
      title: 'Welcome to NEKO POS Dashboard',
      subtitle: 'Manage your coffee shop operations efficiently',
      ra_button: 'React Admin',
      demo_button: 'Demo',
    },
    monthly_revenue: "Today's Revenue",
    new_orders: 'New Orders',
    pending_reviews: 'Pending Reviews',
    new_customers: 'New Customers',
    month_history: "Today's Hourly Sales",
    pending_orders: 'Pending Orders',
    all_reviews: 'All Reviews',
    all_customers: 'All Customers',
    vs_yesterday: 'vs yesterday',
    vs_previous_6_hours: 'vs previous 6 hours',
    need_attention: 'Need attention',
    no_data_available: 'No data available',
    todays_goals: "Today's Goals",
    goals_last_6_hours: 'Goals (Last 6 Hours)',
    performance: 'Performance',
    revenue_last_6_hours: 'Revenue (Last 6 Hours)',
    orders_last_6_hours: 'Orders (Last 6 Hours)',
    customers_last_6_hours: 'Customers (Last 6 Hours)',
    pending_orders_last_6_hours: 'Pending Orders (Last 6 Hours)',
    revenue_last_6_hours_chart: 'Hourly Revenue (Last 6 Hours)',
    top_products_last_6_hours: 'Top Products (Last 6 Hours)',
    orders_needing_attention: 'Orders Needing Attention',
    avg_processing_time: 'Avg. Processing Time',
    satisfaction_rate: 'Satisfaction Rate',
    orders_per_hour: 'Orders per Hour',
    default_customer: 'Customer',
    default_product: 'Product',
    time_just_now: 'Just now',
    time_minutes_ago: 'minutes ago',
    time_hours_ago: 'hours ago',
    time_days_ago: 'days ago',
    top_products: {
      sold: 'Sold',
    },
    error_loading: 'Error loading data',
    network_error: 'Network error',
    network_error_help: 'Please check:',
    network_error_check_server: 'The API server is running',
    network_error_check_connection: 'Your network connection is active',
    network_error_check_proxy: 'The API proxy is configured correctly',
    error_saving: 'Failed to save',
    edit_customer_description: 'Update customer information',
    create_customer_description: 'Create a new customer account',
    showing: 'Showing',
    to: 'to',
    of: 'of',
    page: 'Page',
    customers: 'customers',
  };
